import { DoodCartFunnelValue } from './cart-funnel.model';

type CartFunnelStepValue = Pick<DoodCartFunnelValue, 'required' | 'value' | 'type'>;

/** A funnel step can continue when every required value is filled. A radio step needs one selected choice. */
export function isCartFunnelStepComplete(values: readonly CartFunnelStepValue[]): boolean {
  if (values.some(value => value.type === 'radio')) {
    return values.some(value => Boolean(value.value));
  }

  return values.filter(value => value.required).every(value => Boolean(value.value));
}
